import { useState } from "react";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";

const SnipCommentPanel = ({ thumbnailDataUrl, onSave, onDiscard }) => {
  const [comment, setComment] = useState("");

  return (
    <Stack spacing={1.5} sx={{ p: 2 }}>
      <Typography variant="subtitle2">Flag this region</Typography>
      <Box
        component="img"
        src={thumbnailDataUrl}
        alt="Captured document region"
        sx={{
          maxWidth: "100%",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1
        }}
      />
      <TextField
        label="Comment"
        placeholder="What should we know about this part of the document?"
        value={comment}
        onChange={(event) => setComment(event.target.value)}
        multiline
        minRows={2}
        fullWidth
      />
      <Stack direction="row" spacing={1} justifyContent="flex-end">
        <Button onClick={onDiscard}>Discard</Button>
        <Button
          variant="contained"
          disabled={!comment.trim()}
          onClick={() => onSave({ comment: comment.trim(), thumbnailDataUrl })}
        >
          Save
        </Button>
      </Stack>
    </Stack>
  );
};

export default SnipCommentPanel;
